import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "compare-columns" }
const _hoisted_2 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_3 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_4 = { class: "compare-column" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start mb-3" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["onClick", "aria-label"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.records.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", {
            class: "fas fa-clipboard-list",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("h2", null, "Geen projecten geselecteerd", -1),
          _createElementVNode("p", null, "Ga terug naar de lijstweergave en selecteer projecten om te vergelijken", -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (record) => {
            return (_openBlock(), _createElementBlock("div", {
              key: record.id,
              class: _normalizeClass(_ctx.getColumnClass())
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h2", {
                    class: "h5 mb-0 text-truncate flex-grow-1",
                    title: _ctx.formatValue(record[_ctx.compareFields[0]])
                  }, _toDisplayString(_ctx.formatValue(record[_ctx.compareFields[0]])), 9, _hoisted_6),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-danger ms-2 flex-shrink-0",
                    onClick: ($event: any) => (_ctx.$emit('remove', record.id)),
                    "aria-label": 'Verwijder ' + _ctx.formatValue(record[_ctx.compareFields[0]]) + ' uit de vergelijking'
                  }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("i", {
                      class: "fas fa-times",
                      "aria-hidden": "true"
                    }, null, -1)
                  ]))], 8, _hoisted_7)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailVelden, (field) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: field,
                    class: "field-row"
                  }, [
                    _createElementVNode("div", {
                      class: "field-label text-truncate",
                      title: _ctx.getFieldLabel(field)
                    }, _toDisplayString(_ctx.getFieldLabel(field)), 9, _hoisted_8),
                    _createElementVNode("div", {
                      class: "field-value text-truncate",
                      title: _ctx.formatValue(record[field])
                    }, _toDisplayString(_ctx.formatValue(record[field])), 9, _hoisted_9)
                  ]))
                }), 128))
              ])
            ], 2))
          }), 128))
        ]))
  ]))
}